<template>
	<el-table-column sortable="custom" prop="isShow" :label="title">
	  <template slot-scope="scope">
	 <el-switch @change="isShowChange(scope.row)" v-model="scope.row.isShow"></el-switch>
	  </template>
	</el-table-column>
</template>

<script>
	export default {
			    props: {
			    	title: {
			    		type: String,
			    		default: '是否上架'
			    	},
			    },  
	  data() {
	    return {
			pageName:''
				 }
	  },
			
	  methods: {
				isShowChange(e){
				this.$axios.post(`/api/${this.pageName}/Post${this.pageName}IsShow`,JSON.stringify(e.id.toString())).then(e => {
					 this.$message.success('操作成功到同步服务器');
				  });
				},
			},
			mounted() {
			this.pageName= this.$route.path.replace('/','')
			},
	}
</script>

<style>
</style>
